<template>
  <div class="page_header" :class="{ circle: isCircle }" :style="bodyStyle">
    <div class="tips">
      <slot name="tips"></slot>
    </div>
    <div class="line-icon"></div>
    <div class="box">
      <div class="left">
        <slot name="left"></slot>
      </div>
      <a :href="link" :target="openOut ? '_blank' : '_self'" class="right">
        <slot name="right"></slot>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isCircle: {
      type: Boolean,
      default: false,
    },
    bodyStyle: {
      type: Object,
      default: () => ({
        background: "#fff",
      }),
    },
    link: {
      type: String,
    },
    openOut: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.page_header {
  position: relative;
  height: 60px;
  padding: 16px 0 0 20px;
  //   &.circle {
  //     border-radius: $--border-radius;
  //   }
  .line-icon {
    position: absolute;
    top: 22px;
    left: 0px;
    width: 6px;
    height: 24px;
    background: $--color-primary;
  }
  .box {
    display: flex;
    justify-content: space-between; // @include flex(space-between);
    .left,
    .right {
      display: flex;
      font-size: 14px;
    }
    .right {
      width: 60px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-right: 0;
      text-align: right;
      color: #7d7d7d;
      font-size: 12px;
      &:hover {
        color: $--color-primary;
      }
    }
  }
}
</style>
